import { collapseAnimation } from '../access.animations';
import { Observable } from 'rxjs';
import { Component, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';
import { AppState } from 'src/app/reducers';
import { emailDelegadosFavs, emailPersonal } from '../../home/store/email/email.selectors';
import { AccesoEmail, AccesoEmailFav, AccesoEmailMarkable } from 'src/common/acceso';
import { EmailAccesoRequested, EmailFavInit, EmailsRequested } from '../../home/store/email/email.actions';
import { EmailsFavsToggleRequested } from '../../home/store/acceso/acceso.actions';
import { emailsFavsCollapsed } from '../../home/store/acceso/acceso.selectors';
import { DeviceDetectorService } from 'ngx-device-detector';
import { GtagEvent } from 'src/common/gtagEvent';

@Component({
	selector: 'main-email',
	templateUrl: './main-email.component.html',
	styleUrls: ['./main-email.component.scss'],
	animations: [ collapseAnimation ]
})
export class MainEmailComponent implements OnInit {

	readonly GTAG_CATEGORY: string = 'correo-electronico-widget';

	personal$: Observable<AccesoEmail>;
	delegados$: Observable<AccesoEmailFav[]>;
	isCollapsed$: Observable<boolean>;


	constructor( private store: Store<AppState>, private deviceDetectorService: DeviceDetectorService, private gtag: GtagEvent  ) {
	}

	ngOnInit() {
		this.store.dispatch( new EmailsRequested() );
		this.store.dispatch( new EmailFavInit() );

		this.isCollapsed$ = this.store.select( emailsFavsCollapsed );
		this.personal$ = this.store.select( emailPersonal );
		this.delegados$ = this.store.select( emailDelegadosFavs );
	}

	openEmailPersonal( acceso: AccesoEmailMarkable ) {
		if( this.deviceDetectorService.isDesktop() ) {
			this.gtag.emit( 'abrir-cuenta-personal', this.GTAG_CATEGORY, acceso.emailAbreviado );
			this.store.dispatch( new EmailAccesoRequested( { emailCompleto: acceso.emailCompleto } ) );
		}
	}

	openEmailDelegado( acceso: AccesoEmailMarkable ) {
		if( this.deviceDetectorService.isDesktop() ) {
			this.gtag.emit( 'abrir-cuenta-delegada', this.GTAG_CATEGORY, acceso.emailAbreviado );
			this.store.dispatch( new EmailAccesoRequested( { emailCompleto: acceso.emailCompleto } ) );
		}
	}

	toggleCollapse( event: Event ) {
		this.store.dispatch( new EmailsFavsToggleRequested() );
		event.stopPropagation();
	}

	getEmailStyle() {
		return this.deviceDetectorService.isDesktop()? null: { 'filter': 'grayscale( 100% )', 'opacity': '.5' };
	}

}